<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Product Price ({{ company }})</h4>
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body">
            <form-wrapper :validator="$v.form" class="form-wrapper">
                <form-group name="currency" label="Currency">
                    <md-input v-model="form.currency" type="hidden" />
                    <vue-select
                        data-testid="form-currency"
                        :options="currencyOptions"
                        v-model="form.currency"
                        :clearable="false"
                    ></vue-select>
                </form-group>
                <form-group class="custom-textarea" name="amount" label="Amount">
                    <md-input v-model="form.amount" />
                </form-group>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <md-button class="dialog-button md-primary" @click.stop="update">
                Update
            </md-button>
            <md-button class="dialog-button md-default" @click.stop="$modal.hide">
                Cancel
            </md-button>
        </div>
    </div>
</template>

<script>
import { handleRequests, showErrorMessage } from '@/helpers';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { required, minValue, maxValue } from 'vuelidate/lib/validators';

export default {
    name: 'UpdateProductPricingModal',
    mixins: [GeneralMixin],
    props: {
        teamId: { type: Number, required: true },
        company: { type: String, required: true }
    },
    data() {
        return {
            currencyOptions: ['AUD', 'USD'],
            form: {
                currency: 'AUD',
                amount: 0
            }
        };
    },
    validations() {
        return {
            form: {
                currency: { required },
                amount: { required, minValue: minValue(0), maxValue: maxValue(999) }
            }
        };
    },
    methods: {
        async getCurrentPricing() {
            this.$_handleLoaderState(true, 'Fetching price...');
            const payload = {
                method: 'GET'
            };
            const apiUrl = `/api/billings/support/pricings/${this.teamId}`;
            try {
                const { data } = await handleRequests(apiUrl, payload);

                if (data) {
                    this.form.currency = data.currency;
                    this.form.amount = data.amount;
                }
            } catch (e) {
                const message = 'Failed fetching price.';
                showErrorMessage(this, message, e);
            } finally {
                this.$_handleLoaderState(false);
            }
        },
        async update() {
            try {
                this.$v.form.$touch();

                if (this.$v.form.$invalid) 
                    return;

                this.$_handleLoaderState(true, 'Updating price...');
                const payload = {
                    method: 'POST',
                    data: { currency: this.form.currency, amount: this.form.amount }
                };

                const apiUrl = `/api/billings/support/pricings/${this.teamId}`;

                await handleRequests(apiUrl, payload);
                this.$notify({
                    message: 'Pricing successfully updated.',
                    type: 'success'
                });
                this.$modal.hide();
            } catch (e) {
                const message = 'Failed updating price.';
                showErrorMessage(this, message, e);
            } finally {
                this.$_handleLoaderState(false);
            }
        }
    },
    async mounted() {
        await this.getCurrentPricing();
    }
};
</script>
